import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { VslSection } from './components/VslSection';
import { Testimonials } from './components/Testimonials';
import { ProductBonuses } from './components/ProductBonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2mndpmel5m0uj">
      <StickyBar data-id="element-1" data-mp="31ayqs2ygxpzt" />
      <Hero data-id="element-2" data-mp="31bi9vmzuukff" />
      <main data-id="element-3" data-mp="31c1hoavsjsfq">
        <VslSection data-id="element-4" data-mp="31ctflscv2296" />
        <Testimonials data-id="element-5" data-mp="2wk06ksad07ra" />
        <ProductBonuses data-id="element-6" data-mp="2wjqgz5t882m4" />
        <PurchaseSection data-id="element-7" data-mp="2wiferaffj2x4" />
        <FaqSection data-id="element-8" data-mp="2whxcnx635uha" />
      </main>
      <footer className="bg-forest-deep px-5 py-8 text-center text-xs text-cream/60" data-id="element-9" data-mp="28tw5arkn8k3g">
        © {new Date().getFullYear()} Legado Salud · El Escudo de Mamá. Este material es
        educativo y no sustituye la consulta con tu pediatra.
      </footer>
    </div>;
}